/**
 * @generated SignedSource<<b5bedc1808737cf3fe2ccff0a11d2d68>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteWebhookSubscriptionInput = {
  id: any;
};
export type IncidentIoIntegrationDeleteWebhookSubscriptionMutation$variables = {
  input: DeleteWebhookSubscriptionInput;
};
export type IncidentIoIntegrationDeleteWebhookSubscriptionMutation$data = {
  readonly deleteWebhookSubscription: {
    readonly error: string | null | undefined;
    readonly success: boolean;
  };
};
export type IncidentIoIntegrationDeleteWebhookSubscriptionMutation = {
  response: IncidentIoIntegrationDeleteWebhookSubscriptionMutation$data;
  variables: IncidentIoIntegrationDeleteWebhookSubscriptionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteWebhookSubscriptionPayload",
    "kind": "LinkedField",
    "name": "deleteWebhookSubscription",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IncidentIoIntegrationDeleteWebhookSubscriptionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IncidentIoIntegrationDeleteWebhookSubscriptionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "50b5777e3174ecd3444cfa5e97e3a221",
    "id": null,
    "metadata": {},
    "name": "IncidentIoIntegrationDeleteWebhookSubscriptionMutation",
    "operationKind": "mutation",
    "text": "mutation IncidentIoIntegrationDeleteWebhookSubscriptionMutation(\n  $input: DeleteWebhookSubscriptionInput!\n) {\n  deleteWebhookSubscription(input: $input) {\n    success\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "5a6784bb712c755e99b8ba9b659ebbad";

export default node;
